import React from "react";
import { TABLES } from "../../Utils/tableConst"
import { Table } from "../Table"

export const TableQuery5 = () => (
    <Table tableData={TABLES.QUERY_5} theme="horizontal" />
);
